<template>
  <div id="app" class="">
    <div style="position:absolute;z-index:999;display:flex;flex-direction:column;justify-content:flex-end;align-items:center;width:100%;bottom:0">
      <p style="color:#3e3e3e;">Copyright 2019©喜悦汇-版权所有</p>
      <p style="position:absolute;opacity:0" >喜悦汇是一个华人文化机构,输出极致华人生活方式,中式园林空间，众多知名手艺人等全方位的文化资源。</p>
    </div>
    <router-view name = "main"></router-view>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-size: 16px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: black;
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
html {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue